<template>
    <div class="secret-container">
      <!-- <div class="secret-modal">

      </div> -->
        <div class="secret-header">
          <div class="header-box">
            <div class="header-title">
              מתכונים
            </div>
          </div>
          <div class="header-box">
            <div class="secret-inputs">
              <input type="text" placeholder="חיפוש מתכון">
              <button>מתכון חדש + </button>
            </div>
          </div>
        </div>


        <div class="section">
          <div class="secret-card" v-for="(secret,index) in secrets">
            <span class="secret-item-name">{{secret.Data.name}}</span>
            <pre>{{ secret.Data.note }}</pre>
          </div>
        </div>
    </div>
</template>
<script>
import { db } from '../firebase';
import firebase from "firebase/app";
import moment from 'moment';
import "firebase/storage"
export default {
  name: 'Secret',
  data () {
    return {
      secrets:[],
    }
  },
  created(){
    let vm = this;
    vm.loadSecrets();
  },
  methods:{
    loadSecrets(){
      let vm = this;
      db.collection("Secrets").get().then(function(secretsResult){
        for(let a = 0; a < secretsResult.size; a++){
                  let secretId = secretsResult.docs[a].id;
                  let secret = secretsResult.docs[a].data();
                  // console.log(orderResult.size);
                  vm.secrets.push({ ID: secretId, Data: secret });   
                  vm.totalsecrets = secretsResult.size;



              }
      })
    },
  }
}

</script>
<style scoped>
*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
body{
  overflow: hidden;
}
.secret-container{
  width: 100%;
  padding: 1rem;
}
/* .secret-modal{
  width: 100%;
  height: 100%;
  min-height: 100%;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.2);
} */
.secret-header{
  width: 100%;
  padding: 1rem 0;
  display: flex;
  align-items: center;
}
.header-box{
  width: calc(100% / 2 );
  display: flex;
  align-items: center;
}
.header-title{
  font-size: 25px;
  font-weight: 700;
  letter-spacing: 1px;
}
.secret-inputs{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.secret-inputs input {
  margin-left: 1rem;
  padding: 3px 15px;
  border: 1px solid #e0e0e0;
  background-color: #fafafa;
  font-size: 13px;
  border-radius: 5px;
  min-height: 35px;
}
.secret-inputs button{
  margin: 0;
  background-color: #111926;
  color: #fff;
  font-size: 13px;
  border-radius: 5px;
  min-height: 35px;
  padding: 3px 15px;
  border: 0;
}
.section{
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
}
.section .secret-card{
  width: 300px;
  min-height: 100px;
  border: 1px solid #e0e0e0;
}
.secret-card .secret-item-name{
  padding: 1rem;
  border-bottom: 1px solid #e0e0e0;
  display: block;
  font-weight: 700;
  font-family: 18px;
  text-align: center;
}
.secret-card pre{
  font-family: 'Noto Sans Hebrew';
  padding: 10px;
  font-weight: 500;
  font-size: 14px;
  background-color: #f5f5f5;
}
</style>


// WEBPACK FOOTER //
// src/pages/Secret.vue